<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="title">
            {{ $tc('add_node') }}
          </span>
          <v-spacer />
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="closeModal()">
                <v-icon outline>
                  close
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $tc('close') }}</span>
          </v-tooltip>
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :autofocus="open"
                  ref="ip"
                  :label="$tc('ip')"
                  :hint="$tc('ip_hint')"
                  v-model="ip"
                  :error-messages="ipErrors"
                  @input="$v.ip.$touch()"
                  @keypress="onlyNumber"
                />
              </v-col>
              <v-col>
                <v-row no-gutters justify="end">
                  <v-btn
                    color="blue"
                    type="submit"
                    :loading="loading"
                    :disabled="$v.$invalid"
                    :dark="!$v.$invalid"
                  >
                    {{ $t('add') }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import InputsMixin from '@/mixins/inputs'

const RNM_ADD = 3
export default {
  mixins: [InputsMixin],
  props: {
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open,
      loading: false,
      ip: null
    }
  },
  computed: {
    ipErrors () {
      const errors = []
      if (!this.$v.ip.$dirty) return errors
      !this.$v.ip.required && errors.push(this.$t('$validation.required'))
      !this.$v.ip.isValidIP && errors.push(this.$t('$validation.ip_not_valid'))
      return errors
    }
  },
  validations () {
    const validation = {}

    const isValidIP = value => {
      if (!value) return true

      const expression = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/

      const res = expression.test(value)
      return res
    }

    validation.ip = {
      required,
      isValidIP
    }
    return validation
  },
  methods: {
    closeModal (err) {
      this.dialog = false
      this.loading = false
      this.clear()
      if (err) {
        return this.$emit('error', err)
      }
      return this.$emit('close')
    },
    addIP () {
      this.loading = true
      this.$store
        .dispatch('hsm/replNodeMsg', { body: { op: RNM_ADD, peer: this.ip } })
        .then(() => {
          this.ip = ''
          this.$emit('success')
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
          this.$emit('error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit () {
      return this.addIP()
    },
    clear () {
      this.ip = null
      this.$v.$reset()
    },
    focusIP () {
      this.$nextTick(this.$refs.ip.focus)
    }
  },
  watch: {
    open (val) {
      this.dialog = val

      if (val) {
        // this.focusIP()
      }
    }
  }
}
</script>
